import axios from 'axios';
import { FeatureConfig } from '@/utils/constants/featuresFlag';
import { attachAuthInterceptor } from '@/core/interceptors/authInterceptor';
import { attachErrorInterceptor } from '@/core/interceptors/errorInterceptor';
import { HTTP_METHODS } from '@/utils/constants/httpMethods';
import { API_VERSION } from '@/utils/constants/commonConstants';
import { Constants } from '@/utils/constants/commonConstants';

// Function to create axios instance dynamically
const createApiClient = baseUrlKey => {
  const baseURL =
    import.meta.env[FeatureConfig[baseUrlKey]] ||
    import.meta.env[FeatureConfig.apiUrl];

  const client = axios.create({
    baseURL,
    timeout: 30000
  });

  // Attach interceptors
  attachAuthInterceptor(client);
  attachErrorInterceptor(client);

  return client;
};

// Function to get mock data
const getMockData = async config => {
  const method = config?.method || HTTP_METHODS.GET;
  if (method === HTTP_METHODS.GET && config?.mockData) {
    return config?.mockData;
  }
  if (method === HTTP_METHODS.GET && config?.mockPath) {
    const mockData = await import(config.mockPath);
    return mockData.default || {};
  }
  return {};
};

// Main request function
export const request = async (config, options = {}, queryParams = '') => {
  const method = config?.method || HTTP_METHODS.GET;
  let endPoint = '';

  if (config?.baseUrlKey) {
    endPoint = `/${config.endPoint}`;
  } else {
    endPoint = `${config?.version || API_VERSION.V1}/${config.endPoint}`;
  }

  // Handle query params
  if (
    (method === HTTP_METHODS.GET ||
      (method === HTTP_METHODS.POST &&
        config?.multipart === Constants.Multipart)) &&
    queryParams
  ) {
    endPoint = `${endPoint}?${queryParams}`;
  }

  const defaultOptions = {
    method,
    url: endPoint,
    headers: {
      'Content-Type': config?.contentType || 'application/json',
      ...config?.headers
    },
    ...options
  };

  // Dynamically create client based on baseUrlKey or fallback to apiUrl
  const baseUrlKey = config?.baseUrlKey || 'apiUrl'; // Default to 'apiUrl' if not provided
  const apiClient = createApiClient(baseUrlKey);

  let response = {};
  try {
    response = await apiClient(defaultOptions);
  } catch (err) {
    const mockRes = await getMockData(config);
    return mockRes;
  }
  return response?.data;
};
